<router-outlet></router-outlet>

<!-- Sentry Test Button (commented out for production) -->
<!-- <div class="fixed bottom-4 right-4 z-50">
    <button
        (click)="throwTestError()"
        class="rounded bg-red-500 px-4 py-2 font-bold text-white shadow-lg hover:bg-red-700"
    >
        Test Sentry Error
    </button>
</div> -->
